module.exports = __webpack_public_path__ + "static/media/ulip.68ed3c0f.mp3";